import {
	ADD_TO_CART,
	REMOVE_FROM_CART,
	GET_CART_SUCCESS,
	UPDATE_CART_ITEM_QUANTITY,
} from '../actions/index';

const initialState = {
	items: [],
};

const cartReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_TO_CART: {
			const match = (item) =>
				item.product_id === action.payload.product_id &&
				(item.variant_id || null) === (action.payload.variant_id || null);
			if (state.items == null || state.items.length === 0) {
				return { ...state, items: [{ ...action.payload, quantity: 1 }] };
			}
			return {
				...state,
				items: state.items.find(match)
					? state.items.map((item) => match(item) ? { ...item, quantity: item.quantity + 1 } : item)
					: [...state.items, { ...action.payload, quantity: 1 }],
			};
		}
		case GET_CART_SUCCESS:
			return {
				...state,
				items: Array.isArray(action.payload) ? action.payload : [],
			};
		case UPDATE_CART_ITEM_QUANTITY:
			return {
				...state,
				items: state.items.map((item) =>
					item.product_id === action.payload.product_id &&
					(item.variant_id || null) === (action.payload.variant_id || null)
						? { ...item, quantity: action.payload.quantity }
						: item
				),
			};
		case REMOVE_FROM_CART:
			return {
				...state,
				items: state.items.filter((item) =>
					!(item.product_id === action.payload.product_id &&
					(item.variant_id || null) === (action.payload.variant_id || null))
				),
			};
		default:
			return state;
	}
};

export default cartReducer;
